<template>
  <div>
    <Drawer :isDrawerOpen="isDrawerOpen" @toggle-drawer="toggleDrawer" />
    <Navigation @toggle-drawer="toggleDrawer" />
    <router-view name="client-view" />
    <Footer />
  </div>
</template>

<script>
import Drawer from '@/components/Drawer.vue';
import Navigation from '@/components/Navigation.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'ClientView',
  components: {
    Drawer,
    Footer,
    Navigation,
  },
  data() {
    return {
      isDrawerOpen: false,
    };
  },
  methods: {
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
  },
};
</script>
